import React from 'react'
import PropTypes from 'prop-types'
import { Background } from './Background'
import { Overlay } from './Overlay'
import CallToActionContainer from 'LiveBoard/containers/CallToActionContainer'
import { CTA_AREAS } from 'LiveBoard/components/shared/CallToAction/constants'
import withDeviceHeightResize from 'LiveBoard/components/shared/hocs/withDeviceHeightResize'
import { LIVE_BOARD_CLASSNAMES } from 'shared/constants'
import {
  ConfigurableFormPresenter
} from 'LiveBoard/components/shared/CallToAction/types/forms/ConfigurableForms'
import { CTA_FORM_NAMES } from 'LiveBoard/components/shared/CallToAction/types/forms/constants'
import get from 'lodash/get'

export const BANNER_TYPES = {
  basic: 'basic',
  short: 'short',
  medium: 'medium',
  tall: 'tall'
}

const BANNER_TYPE_CONFIG = {
  [BANNER_TYPES.basic]: { hasMedia: false },
  [BANNER_TYPES.short]: { hasMedia: true },
  [BANNER_TYPES.medium]: { hasMedia: true },
  [BANNER_TYPES.tall]: { hasMedia: true }
}

const FORM_MARGIN_FROM_CONTENT = 40

class CustomBanner extends React.Component {

  componentDidMount() {
    if (this.props.isMobile) {
      setTimeout(this.setMobilePositionFormOnBoard, 1000)
    }
  }

  setMobilePositionFormOnBoard = () => {
    if (this.bannerContentRef && this.bannerFormRef) {
      const contentBottom = this.bannerContentRef.getBoundingClientRect().bottom
      const formTop = this.bannerFormRef.getBoundingClientRect().top
      const bannerMarginTop = - (formTop - contentBottom) + FORM_MARGIN_FROM_CONTENT
      this.bannerFormRef.style.marginTop = `${bannerMarginTop}px`
    }
  }

  render() {
    const config = this.props.config
    const typeConfig = BANNER_TYPE_CONFIG[config.height]
    const textAlignment = config.text_alignment

    const backgroundConfig = this.props.isMobile && config.mobile_background.show ?
      config.mobile_background : config.background
    const background = {
      ...backgroundConfig,
      height: config.height
    }

    const titleText = get(config, 'header.text')
    const titleStyle = this.props.isMobile && !!titleText && titleText.length > 40 ? { fontSize: "2.8rem" } : {}
    const subtitleText = get(config, 'subtitle.text')
    const subtitleStyle = this.props.isMobile && !!subtitleText && subtitleText.length > 150 ? (
      subtitleText.length > 220 ? (
        window && window.innerWidth > 320 ? { fontSize: "1.4rem" } : { fontSize: "1.3rem" }
      ) : { fontSize: "1.6rem" }
    ) : {}

    /*
      It is really important that the banner height doesn't use vh units
      in order for embedded board to work properly.
      This is the reason for this implementation
    */

    const bannerStyle = this.props.isMobile ? { height: `${this.props.deviceHeight}px` } : {}

    return (
      <section className="banner-box">
        <div className={`${LIVE_BOARD_CLASSNAMES.banner} ${config.height}`} style={bannerStyle}>
          { typeConfig.hasMedia && <Background config={background}/> }
          { typeConfig.hasMedia && (
            <Overlay tint={background.tint} themeColorHex={this.props.themeColorHex} />
          )}
          { this.props.showContent &&
            <div>
              <div className={`banner-content align-${textAlignment}`} ref={ref => this.bannerContentRef = ref}>
                <div className={`banner-text ${config.text_color}`} style={{ color: this.props.textColor }}>
                  <h1 style={titleStyle}>{titleText}</h1>
                  <p style={subtitleStyle}>{subtitleText}</p>
                </div>
                { config.cta.show && (
                  <CallToActionContainer
                    area={CTA_AREAS.banner}
                    themeColorHex={this.props.themeColorHex}
                    config={{...config.cta}} />
                )}
              </div>
            </div> }
            { this.props.children }
        </div>
        { this.props.showContent && config.form.show && config.form.form && (
          <div className="banner-form" ref={ref => this.bannerFormRef = ref}>
            <div className={`banner-form-wrapper ${this.props.isItemView ? 'banner-form-with-item-view' : ''}`}>
              <ConfigurableFormPresenter
                area={CTA_AREAS.banner}
                config={{...config.form}}
                form={CTA_FORM_NAMES.customFormOnBoard}
                themeColorHex={this.props.themeColorHex} />
            </div>
          </div>
        )}
      </section>
    )
  }
}

CustomBanner.propTypes = {
  config: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  showContent: PropTypes.bool,
  isMobile: PropTypes.bool,
  textColor: PropTypes.string
}

export default withDeviceHeightResize(CustomBanner)

